import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

// 使用完整截止時間判斷；不足一天改用完整小時，最後一小時不顯示零天。
export default function CampaignDeadline({ endDate, stacked = false }: {
  endDate?: string | Date | null; stacked?: boolean;
}) {
  const { t } = useTranslation();
  const [now, setNow] = useState(() => Date.now());
  const end = endDate ? (typeof endDate === "string"
    ? moment(endDate, moment.ISO_8601, true) : moment(endDate)).valueOf() : NaN;
  useEffect(() => {
    setNow(Date.now());
    if (!Number.isFinite(end) || end <= Date.now()) return;
    // 留在頁面時亦更新截止狀態，長時間背景停留後依真正時間重新判斷。
    const tick = () => setNow(Date.now());
    const timer = window.setInterval(tick, 1000);
    window.addEventListener("focus", tick);
    return () => { clearInterval(timer); window.removeEventListener("focus", tick); };
  }, [end]);
  if (!Number.isFinite(end)) return <span>—</span>;
  if (end <= now) return <span>{t("campaign_deadline.ended")}</span>;
  const remaining = end - now;
  if (remaining < 86400000) {
    const hours = Math.floor(remaining / 3600000);
    return <span>{t(hours < 1 ? "campaign_deadline.less_than_hour"
      : hours === 1 ? "campaign_deadline.last_hour" : "campaign_deadline.hours", { count: hours })}</span>;
  }
  const days = moment(end).diff(moment(now), "days");
  return stacked ? <><div>{days}</div><div>{t("campaign_deadline.days_to_go")}</div></>
    : <><span style={{ fontWeight: 600 }}>{days}</span>{" "}{t("campaign_deadline.days_to_go")}</>;
}
